import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

// Small pop-up to jot a note on a shift (what you did that day). Shifts only, not tours.
export const ShiftNoteDialog = ({ shift, onOpenChange, onSaved }) => {
  const open = !!shift;
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (shift) setNote(shift.note || ""); }, [shift]);

  const save = async () => {
    setSaving(true);
    try {
      await api.updateShift(shift.id, { note: note.trim() });
      toast.success(note.trim() ? "Note saved" : "Note cleared");
      onSaved?.();
      onOpenChange(false);
    } catch {
      toast.error("Couldn't save note");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onOpenChange(false)}>
      <DialogContent className="border-zinc-800 bg-zinc-950 sm:max-w-md" data-testid="shift-note-dialog">
        <DialogHeader>
          <DialogTitle className="text-zinc-50">Shift note</DialogTitle>
          <DialogDescription className="text-zinc-400">
            {shift?.label || "Shift"}{shift?.date ? ` · ${shift.date}` : ""}
          </DialogDescription>
        </DialogHeader>

        <Textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="What did you do this day? (e.g. covered the front gate, trained a new guide…)"
          rows={5}
          className="border-zinc-800 bg-zinc-900 text-zinc-100"
          data-testid="shift-note-input"
        />

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-zinc-700 bg-transparent text-zinc-300 hover:bg-zinc-800 hover:text-zinc-100" data-testid="shift-note-cancel">Cancel</Button>
          <Button onClick={save} disabled={saving} className="bg-[#9B2226] text-white hover:bg-[#7A1A1E]" data-testid="shift-note-save">
            {saving ? "Saving…" : "Save note"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
